module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "speaker"
  }, [_c('img', {
    staticClass: "delete-icon delete-speaker",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteWebinarSpeakerAndRedirect(_vm.speaker.id)
      }
    }
  }), _vm._v(" "), (!_vm.speaker.photo) ? _c('div', {
    staticClass: "rounded-photo-wrapper centered speaker-photo",
    on: {
      "click": function($event) {
        return _vm.handleLoadSpeakerPhoto(_vm.speaker.id)
      }
    }
  }, [_c('span', [_vm._v("Сменить фото")])]) : _c('div', {
    staticClass: "speaker-photo with-background-image",
    style: (_vm.photoStyle)
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteWebinarSpeakerPhoto(_vm.speaker.id)
      }
    }
  })]), _vm._v(" "), _c('b-field', {
    class: {
      'is-danger': _vm.errors.has('speaker-name')
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "placeholder": "Имя фамилия",
      "name": "speaker-name"
    },
    on: {
      "change": function($event) {
        return _vm.updateWebinarSpeaker(_vm.speaker)
      }
    },
    model: {
      value: (_vm.speaker.name),
      callback: function($$v) {
        _vm.$set(_vm.speaker, "name", $$v)
      },
      expression: "speaker.name"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Должность, какую компанию представляет"
    },
    on: {
      "change": function($event) {
        return _vm.updateWebinarSpeaker(_vm.speaker)
      }
    },
    model: {
      value: (_vm.speaker.post),
      callback: function($$v) {
        _vm.$set(_vm.speaker, "post", $$v)
      },
      expression: "speaker.post"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleSaveWebinarSpeaker
    }
  }, [_vm._v("СОХРАНИТЬ")])]), _vm._v(" "), _c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a1db6b9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/WebinarSpeaker.vue
// module id = 904
// module chunks = 0